import React from "react";
import styles from "./Dashboard.module.scss";
import { IoMdRefresh } from "react-icons/io";
import { FaLongArrowAltRight } from "react-icons/fa";

const Dashboard = () => {
  return (
    <div className={styles.dashboardPage}>
      <h1 className={styles.dashboardTitle}>
        Статистика <IoMdRefresh />
      </h1>
      <div className={styles.dasboardStatsContainer}>
        <div className={styles.dasboardStatsItem}>
          <h2>
            Пользователей за<span> все время</span>
          </h2>
          <div className={styles.dasboardStatsItemBottom}>
            <span>999+ </span>
            <a href="">
              Перейти к списку <FaLongArrowAltRight size={12} />
            </a>
          </div>
        </div>
        <div className={styles.dasboardStatsItem}>
          <h2>
            Пользователей за <span>неделю</span>
          </h2>
          <div className={styles.dasboardStatsItemBottom}>
            <span>999+ </span>
            <a href="">
              Перейти к списку <FaLongArrowAltRight size={12} />
            </a>
          </div>
        </div>
        <div className={styles.dasboardStatsItem}>
          <h2>
            Пользователей за <span>сегодня</span>
          </h2>
          <div className={styles.dasboardStatsItemBottom}>
            <span>999+ </span>
            <a href="">
              Перейти к списку <FaLongArrowAltRight size={12} />
            </a>
          </div>
        </div>
        <div className={styles.dasboardStatsItem}>
          <h2>
            Агентов за<span> все время</span>
          </h2>
          <span>999+</span>
        </div>
        <div className={styles.dasboardStatsItem}>
          <h2>
            Агентов за <span>неделю</span>
          </h2>
          <span>999+</span>
        </div>
        <div className={styles.dasboardStatsItem}>
          <h2>
            Агентов за <span>сегодня</span>
          </h2>
          <span>999+</span>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
